export const uploadFile = process.env.VUE_APP_BASE_API + 'upload/file';
import request from '@/utils/request';
export const messageSort = {
  AUDIT_FLOW: '审核流相关',
  INSURE: '投保相关',
  TASK_LIST: '任务列表相关',
  SURRENDER_INSURANCE: '退保相关'
};
export function sceneList(data) {
  return request.post('admin/scene/list', data);
}
export function sceneConfigList(data) {
  return request.post('admin/scene/config/list', data);
}
export function sceneConfigAdd(data) {
  return request.post('admin/scene/store', data);
}
export function sceneConfigEdit(data) {
  return request.post('admin/scene/edit', data);
}
export function sceneVariableResource(data) {
  return request.post('admin/scene/variable', data);
}
export function allMessageList(data) {
  return request.post('admin/note/resource', data);
}